var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _g, _path7, _path8, _rect3, _rect4, _path9, _path10, _path11, _g2, _path12, _path13, _rect5, _rect6, _path14, _path15, _path16, _path17, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSplitPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 159,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1395 78.7158C14.2494 58.5052 38.3189 43.2752 66.7157 33.7036C95.3056 24.0669 131.3 18.6511 164.075 28.1778C195.098 37.1953 206.435 58.469 217.285 77.4696C227.178 94.7956 239.339 115.202 220.957 127.794C203.642 139.654 169.178 129.687 140.969 129.745C114.864 129.798 89.1158 137.328 66.2025 128.109C37.4903 116.557 14.0352 97.8996 14.1395 78.7158Z",
    fill: "#FAF9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.214 69.4545C125.214 69.9736 124.793 70.3945 124.274 70.3945L113.94 70.3945C113.421 70.3945 113 70.8153 113 71.3345L113 87.2955C113 87.8147 113.421 88.2355 113.94 88.2355L124.274 88.2355C124.793 88.2355 125.214 88.6564 125.214 89.1755L125.214 93.4321C125.214 94.308 126.307 94.7079 126.872 94.039L138.807 79.9219C139.103 79.5715 139.103 79.0585 138.807 78.7081L126.872 64.591C126.307 63.9221 125.214 64.322 125.214 65.1979L125.214 69.4545Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.39 87.6172V27.4958C193.39 25.7703 194.747 24.3902 196.398 24.3902H231.451L245.635 38.9845V87.6172C245.635 89.3427 244.279 90.7228 242.628 90.7228H196.398C194.747 90.7228 193.39 89.3434 193.39 87.6172Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.628,
    y: 68.8721,
    width: 39.7685,
    height: 16.3881,
    rx: 1.7057,
    fill: "#D2294B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 199.628,
    y: 68.8721,
    width: 39.7685,
    height: 16.3881,
    rx: 1.7057,
    stroke: "#D2294B",
    strokeWidth: 0.780384
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.081 80.5595V73.5732H213.254C214.029 73.5732 214.626 73.7714 215.047 74.1678C215.467 74.5576 215.677 75.1026 215.677 75.8029C215.677 76.5032 215.467 77.0515 215.047 77.4479C214.626 77.8443 214.029 78.0425 213.254 78.0425H211.608V80.5595H210.081ZM211.608 76.8533H212.997C213.805 76.8533 214.209 76.5032 214.209 75.8029C214.209 75.1158 213.805 74.7723 212.997 74.7723H211.608V76.8533Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.624 80.5595V73.5732H219.343C220.526 73.5732 221.442 73.8771 222.092 74.4849C222.743 75.0861 223.068 75.9449 223.068 77.0614C223.068 78.1779 222.743 79.0401 222.092 79.6478C221.442 80.2556 220.526 80.5595 219.343 80.5595H216.624ZM218.151 79.301H219.255C220.733 79.301 221.472 78.5545 221.472 77.0614C221.472 75.575 220.733 74.8318 219.255 74.8318H218.151V79.301Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M224.254 80.5595V73.5732H228.944V74.7723H225.781V76.4768H228.727V77.6758H225.781V80.5595H224.254Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.364 43.8995H236.706C237.353 43.8995 237.877 44.4236 237.877 45.07V46.6308C237.877 47.2773 237.353 47.8014 236.706 47.8014H202.364C201.718 47.8014 201.194 47.2773 201.194 46.6308V45.07C201.194 44.4236 201.718 43.8995 202.364 43.8995Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.364 51.7037H236.706C237.353 51.7037 237.877 52.2278 237.877 52.8742V54.435C237.877 55.0815 237.353 55.6056 236.706 55.6056H202.364C201.718 55.6056 201.194 55.0815 201.194 54.435V52.8742C201.194 52.2278 201.718 51.7037 202.364 51.7037Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.364 59.5069H236.706C237.353 59.5069 237.877 60.031 237.877 60.6775V62.2382C237.877 62.8847 237.353 63.4088 236.706 63.4088H202.364C201.718 63.4088 201.194 62.8847 201.194 62.2382V60.6775C201.194 60.031 201.718 59.5069 202.364 59.5069Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.18 35.3933V24.9646L245.146 38.3676H235.045C233.475 38.3676 232.18 37.0487 232.18 35.3933Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.39 136.617V76.4958C157.39 74.7703 158.747 73.3902 160.398 73.3902H195.451L209.635 87.9845V136.617C209.635 138.343 208.279 139.723 206.628 139.723H160.398C158.747 139.723 157.39 138.343 157.39 136.617Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 163.628,
    y: 117.872,
    width: 39.7685,
    height: 16.3881,
    rx: 1.7057,
    fill: "#D2294B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 163.628,
    y: 117.872,
    width: 39.7685,
    height: 16.3881,
    rx: 1.7057,
    stroke: "#D2294B",
    strokeWidth: 0.780384
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.081 129.559V122.573H177.254C178.029 122.573 178.626 122.771 179.047 123.167C179.467 123.557 179.677 124.102 179.677 124.802C179.677 125.503 179.467 126.051 179.047 126.447C178.626 126.844 178.029 127.042 177.254 127.042H175.608V129.559H174.081ZM175.608 125.853H176.997C177.805 125.853 178.209 125.503 178.209 124.802C178.209 124.115 177.805 123.772 176.997 123.772H175.608V125.853Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M180.624 129.559V122.573H183.343C184.526 122.573 185.442 122.877 186.092 123.484C186.743 124.086 187.068 124.944 187.068 126.061C187.068 127.177 186.743 128.04 186.092 128.647C185.442 129.255 184.526 129.559 183.343 129.559H180.624ZM182.151 128.301H183.255C184.733 128.301 185.472 127.554 185.472 126.061C185.472 124.575 184.733 123.831 183.255 123.831H182.151V128.301Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188.254 129.559V122.573H192.944V123.772H189.781V125.476H192.727V126.675H189.781V129.559H188.254Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.364 92.8995H200.706C201.353 92.8995 201.877 93.4236 201.877 94.07V95.6308C201.877 96.2773 201.353 96.8014 200.706 96.8014H166.364C165.718 96.8014 165.194 96.2773 165.194 95.6308V94.07C165.194 93.4236 165.718 92.8995 166.364 92.8995Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.364 100.703H200.706C201.353 100.703 201.877 101.227 201.877 101.874V103.435C201.877 104.081 201.353 104.605 200.706 104.605H166.364C165.718 104.605 165.194 104.081 165.194 103.435V101.874C165.194 101.227 165.718 100.703 166.364 100.703Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.364 108.507H200.706C201.353 108.507 201.877 109.031 201.877 109.677V111.238C201.877 111.885 201.353 112.409 200.706 112.409H166.364C165.718 112.409 165.194 111.885 165.194 111.238V109.677C165.194 109.031 165.718 108.507 166.364 108.507Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.181 84.3933V73.9646L209.146 87.3676H199.045C197.476 87.3676 196.181 86.0487 196.181 84.3933Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 0.780384
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.639706 128.298V29.7312C0.639706 26.9024 2.8636 24.6397 5.57028 24.6397H63.0383L86.2933 48.5665V128.298C86.2933 131.127 84.0694 133.39 81.3627 133.39H5.57028C2.8647 133.39 0.639706 131.128 0.639706 128.298Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8668,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    fill: "#D2294B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.8668,
    y: 97.566,
    width: 65.199,
    height: 26.8676,
    rx: 2.79643,
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0039 116.727V105.273H33.2053C34.476 105.273 35.456 105.598 36.1452 106.248C36.8344 106.887 37.179 107.78 37.179 108.928C37.179 110.076 36.8344 110.975 36.1452 111.625C35.456 112.275 34.476 112.6 33.2053 112.6H30.5077V116.727H28.0039ZM30.5077 110.651H32.7853C34.1099 110.651 34.7722 110.076 34.7722 108.928C34.7722 107.802 34.1099 107.239 32.7853 107.239H30.5077V110.651Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7307 116.727V105.273H43.1891C45.1275 105.273 46.6297 105.771 47.6959 106.768C48.762 107.753 49.295 109.161 49.295 110.992C49.295 112.822 48.762 114.236 47.6959 115.232C46.6297 116.229 45.1275 116.727 43.1891 116.727H38.7307ZM41.2345 114.663H43.0437C45.4667 114.663 46.6782 113.44 46.6782 110.992C46.6782 108.555 45.4667 107.336 43.0437 107.336H41.2345V114.663Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2401 116.727V105.273H58.9291V107.239H53.7439V110.033H58.5737V111.999H53.7439V116.727H51.2401Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2349 42.6789V25.5814L85.4915 47.5552H68.9312C66.3578 47.5552 64.2349 45.3929 64.2349 42.6789Z",
    fill: "white",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 56.6251H67C67.7513 56.6251 68.3603 57.2341 68.3603 57.9854V61.6007C68.3603 62.352 67.7513 62.961 67 62.961H21C20.2487 62.961 19.6397 62.352 19.6397 61.6007V57.9854C19.6397 57.2341 20.2487 56.6251 21 56.6251Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 69.3174H67C67.7513 69.3174 68.3603 69.9265 68.3603 70.6777V74.2931C68.3603 75.0444 67.7513 75.6534 67 75.6534H21C20.2487 75.6534 19.6397 75.0444 19.6397 74.2931V70.6777C19.6397 69.9265 20.2487 69.3174 21 69.3174Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 82.0098H67C67.7513 82.0098 68.3603 82.6188 68.3603 83.3701V86.9855C68.3603 87.7367 67.7513 88.3458 67 88.3458H21C20.2487 88.3458 19.6397 87.7367 19.6397 86.9855V83.3701C19.6397 82.6188 20.2487 82.0098 21 82.0098Z",
    fill: "#D2294B",
    stroke: "#D2294B",
    strokeWidth: 1.27941
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSplitPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/split_pdf.1f8a4fcd1bb3231c4dfe1bc58df4e633.svg";